import { render, staticRenderFns } from "./OCheckBox.vue?vue&type=template&id=1068649f&scoped=true&"
import script from "./OCheckBox.vue?vue&type=script&lang=js&"
export * from "./OCheckBox.vue?vue&type=script&lang=js&"
import style0 from "./OCheckBox.vue?vue&type=style&index=0&id=1068649f&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1068649f",
  null
  
)

export default component.exports